import { useContext } from 'react'
import AuthContext from '@/contexts/AuthContext'

interface AuthContextType {
  user: import('@/contexts/AuthContext').CustomerUser | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  signIn: (accessCode: string, passphrase: string) => Promise<void>
  signOut: () => Promise<void>
  clearError: () => void
}

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
